import { report } from './index';
export function buryingPoint (index, title, axios) {
	let arr = ['12019', '12020', '12021']
	report(arr[index])
	let itemid = ''
	if (title === 'subscribe') {
		itemid = '12017'
	} else if (title === 'share') {
		itemid = '12013'
	} else if (title === 'link') {
		itemid = arr[index]
	}
	report(itemid)
}



// WEBPACK FOOTER //
// ./src/components/actModules/h5/templates/buryingPoint/button.js